import { get } from "./utils";

export const getLocale = async () => await get<string>(`locale/`);
